import { unSentence } from 'gleam-shared/helpers/toSentence'
import { isArray, toString } from 'gleam-shared/helpers/nodash'

export default function oxfordComma(...input) {
  if (isArray(input[0])) {
    input = input[0]
  }

  const list = input.map(toString).map(opinionatedTrim)

  if (list.length === 0) {
    return ''
  } else if (list.length === 1) {
    return list[0]
  } else if (list.length === 2) {
    return list[0] + ' and ' + list[1]
  } else {
    return list.slice(0, -1).join(', ') + ', and ' + list.at(-1)
  }
}

function opinionatedTrim(input) {
  return unSentence(input).trim()
}
